import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetBody } from '@ps-design-system/components/Sheet';
import CheckCircleIcon from '@ps-design-system/icons/CheckCircle/CheckCircle24';

import { useUploadModal } from '../context/UploadModalContext';

const UploaderTips = () => {
  const { openTips, setTipsOpen } = useUploadModal();
  return (
    <Sheet open={openTips} onOpenChange={setTipsOpen} >
      <SheetContent
        side="right"
      >
        <SheetHeader
          showCloseButton
          headerAlignment="left"
        >
          <SheetTitle className="tips-header">
            <FormattedMessage id="uploader.tips.empty_header" defaultMessage="Tips to make your gallery stand out"/>
          </SheetTitle>
        </SheetHeader>
        <SheetBody>
          <div className='tips'>
            <div className='uploader-row'>
              <div className='icon tw-text-purple-800'><CheckCircleIcon /></div>
              <div className='uploader-column'>
                <div>
                  <Text typeface="body-2-m">
                    <FormattedMessage id="uploader.tips.high_quality" defaultMessage="High quality, wide shots"/>
                  </Text>
                </div>
                <div>
                  <Text typeface="body-2-long">
                    <FormattedMessage id="uploader.tips.high_quality_description" defaultMessage="Use horizontal photos that are at least 1,000 pixels wide."/>
                  </Text>
                </div>
              </div>
            </div>
            <div className='uploader-row'>
              <div className='icon tw-text-purple-800'><CheckCircleIcon /></div>
              <div className='uploader-column'>
                <div>
                  <Text typeface="body-2-m">
                    <FormattedMessage id="uploader.tips.showcase" defaultMessage="Showcase your whole space"/>
                  </Text>
                </div>
                <div>
                  <Text typeface="body-2-long">
                    <FormattedMessage id="uploader.tips.showcase_description" defaultMessage="Peerspace requires a minimum of 5 photos but we recommend adding 10 or more to give a better idea of the layout and rooms."/>
                  </Text>
                </div>
              </div>
            </div>
            <div className='uploader-row'>
              <div className='icon tw-text-purple-800'><CheckCircleIcon /></div>
              <div className='uploader-column'>
                <div>
                  <Text typeface="body-2-m">
                    <FormattedMessage id="uploader.tips.natural_light" defaultMessage="Use natural color and light"/>
                  </Text>
                </div>
                <div>
                  <Text typeface="body-2-long">
                    <FormattedMessage id="uploader.tips.natural_light_description" defaultMessage="No black & white or heavy filters. Because bright, well-lit space feel more welcoming, we recommend taking photos in natural daylight."/>
                  </Text>
                </div>
              </div>
            </div>
            <div className='uploader-row'>
              <div className='icon tw-text-purple-800'><CheckCircleIcon /></div>
              <div className='uploader-column'>
                <div>
                  <Text typeface="body-2-m">
                    <FormattedMessage id="uploader.tips.simple" defaultMessage="Keep it simple"/>
                  </Text>
                </div>
                <div>
                  <Text typeface="body-2-long">
                    <FormattedMessage id="uploader.tips.simple_description" defaultMessage="No watermarks, collages, or screenshots."/>
                  </Text>
                </div>
              </div>
            </div>
            <div className='uploader-row'>
              <div className='icon tw-text-purple-800'><CheckCircleIcon /></div>
              <div className='uploader-column'>
                <div>
                  <Text typeface="body-2-m">
                    <FormattedMessage id="uploader.tips.declutter" defaultMessage="Declutter the space"/>
                  </Text>
                </div>
                <div>
                  <Text typeface="body-2-long">
                    <FormattedMessage id="uploader.tips.declutter_description" defaultMessage="Clear surfaces and good staging help people imagine themselves there."/>
                  </Text>
                </div>
              </div>
            </div>
            <div className='uploader-row'>
              <div className='icon tw-text-purple-800'><CheckCircleIcon /></div>
              <div className='uploader-column'>
                <div>
                  <Text typeface="body-2-m">
                    <FormattedMessage id="uploader.tips.highlight" defaultMessage="Highlight your space’s unique style"/>
                  </Text>
                </div>
                <div>
                  <Text typeface="body-2-long">
                    <FormattedMessage id="uploader.tips.highlight_description" defaultMessage="Include details that show off your space’s personality. Plants, artwork, or cozy lighting go a long way."/>
                  </Text>
                </div>
              </div>
            </div>
            <div className='uploader-row'>
              <div className='icon tw-text-purple-800'><CheckCircleIcon /></div>
              <div className='uploader-column'>
                <div>
                  <Text typeface="body-2-m">
                    <FormattedMessage id="uploader.tips.capture" defaultMessage="Capture the vibe"/>
                  </Text>
                </div>
                <div>
                  <Text typeface="body-2-long">
                    <FormattedMessage id="uploader.tips.capture_description" defaultMessage="Upload photos of past events or setups to help guests picture how they could use your space."/>
                  </Text>
                </div>
              </div>
            </div>
          </div>
        </SheetBody>
      </SheetContent>
    </Sheet>
  );
};

export default UploaderTips;
